<div class="aip-toolbar" *ngIf="true">


    <input type="text" class="aip-widget-search aip-widget-search-input" placeholder="Search Logos" [(ngModel)]="searchLogos" />            

    <span class="spacer"></span>
    <button matTooltip="Logo Manager" class="aip-button" mat-raised-button (click)="openLogo()">
        <fa-icon class="" icon="file-image"></fa-icon>
        Logo Manager
    </button>

   <button matTooltip="Sync With AIC" class="aip-button" mat-raised-button (click)="syncWithAIC()">
        <fa-icon class="" icon="sync"></fa-icon>
        Sync AIC
    </button>
</div>

<div class="logo-holder">
    <div [matTooltip]="'File:' + v.name + '\n' + 'Source:' + v.source" class="logo" *ngFor="let v of getLogosList()" (click)="openLogo(v.id)">   
        <img class="image-fit" [src]="'/logos/'+v.file">
    </div>
</div>
